export default "__VITE_ASSET__DhUneMQ5__";